var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit } from "vue-property-decorator";
import { WorkOrderService } from "~/services/business-service/work-order.service";
var AppendWorkOrder = /** @class */ (function (_super) {
    __extends(AppendWorkOrder, _super);
    function AppendWorkOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = { date: '', content: '', caseId: '', certificateNo: '' };
        _this.loading = { state: false };
        _this.rules = {
            date: [{ required: true, message: "请选择时间", trigger: "blur" }],
            content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        };
        return _this;
    }
    AppendWorkOrder.prototype.close = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    AppendWorkOrder.prototype.save = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.loading.state = true;
            _this.model.caseId = _this.currentDate.id;
            _this.model.certificateNo = _this.currentDate.certificateNo;
            _this.workOrderService.addWorkOrder(_this.model, _this.loading).subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(WorkOrderService)
    ], AppendWorkOrder.prototype, "workOrderService", void 0);
    __decorate([
        Prop({ required: true })
    ], AppendWorkOrder.prototype, "currentDate", void 0);
    __decorate([
        Emit("close")
    ], AppendWorkOrder.prototype, "close", null);
    AppendWorkOrder = __decorate([
        Component({
            components: {}
        })
    ], AppendWorkOrder);
    return AppendWorkOrder;
}(Vue));
export default AppendWorkOrder;
